import { Box } from "@mui/material";

const UserImage = ({ image, size = "200px" }) => {
  return (
    <Box width={size} height={size} border="1px solid red">
      <img
        style={{ objectFit: "cover", borderRadius: "50%" }}
        width={size}
        height={size}
        alt="user"
        src={`http://localhost:5001/uploads/profilePics/${image}`}
      />
    </Box>
  );
};

export default UserImage;
